var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rebate" }, [
    _c("div", { staticClass: "rebate_header" }, [
      _c("div", { staticClass: "time_box" }, [
        _c("div", { staticClass: "time_header" }, [
          _vm._v("距离日结算结束时间还有"),
        ]),
        _c("div", { staticClass: "time_content" }, [
          _c("i", [_vm._v(_vm._s(_vm.counterTime.hour[0]))]),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.hour[1]))]),
          _vm._v("时 "),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.min[0]))]),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.min[1]))]),
          _vm._v("分 "),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.sec[0]))]),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.sec[1]))]),
          _vm._v("秒 "),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.user.nickname,
              expression: "!user.nickname",
            },
          ],
          staticClass: "rebate-Mask",
          style: !_vm.user.nickname ? "opacity:1;" : "",
        },
        [
          _c("div", { staticClass: "end-img" }, [
            _c(
              "div",
              { staticClass: "viewDetail", on: { click: _vm.loginbtnClick } },
              [_vm._v("请登录")]
            ),
          ]),
        ]
      ),
    ]),
    _vm._m(0),
    _c(
      "div",
      {
        staticClass: "get-subsidy-btn",
        on: {
          click: function ($event) {
            return _vm.takeSubsidy()
          },
        },
      },
      [_vm._v("点击领取")]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rebate_desc_box" }, [
      _c("div", { staticClass: "event_rulebox" }, [
        _c("div", { staticClass: "title" }, [_vm._v("救援奖励计算规则")]),
        _c("div", { staticClass: "content" }, [
          _c("br"),
          _c("div", { staticClass: "rule_line" }, [
            _c("span", [_vm._v("领取规则：")]),
          ]),
          _c("div", { staticClass: "rule_line" }, [
            _c("b", [_vm._v("日救援: 每日计算一次，结算时间：第二天的")]),
            _c("span", { staticStyle: { color: "#F5B844" } }, [
              _vm._v("20：30"),
            ]),
          ]),
          _c("div", { staticClass: "rule_line" }, [
            _c("b", [_vm._v("白给100以下不给与救援")]),
          ]),
          _c("div", { staticClass: "rule_line" }, [
            _c("b", [_vm._v("VIP1-5白给100-5000，救援比例")]),
            _c("span", { staticStyle: { color: "#F5B844" } }, [_vm._v("3%")]),
            _vm._v(" "),
            _c("b", [_vm._v("；5000以上救援比例")]),
            _c("span", { staticStyle: { color: "#F5B844" } }, [_vm._v("4%")]),
          ]),
          _c("div", { staticClass: "rule_line" }, [
            _c("b", [_vm._v("VIP6以上白给100-5000，救援比例")]),
            _c("span", { staticStyle: { color: "#F5B844" } }, [_vm._v("4%")]),
            _c("b", [_vm._v("；5000以上救援比例")]),
            _c("span", { staticStyle: { color: "#F5B844" } }, [_vm._v("5%")]),
          ]),
          _c(
            "div",
            { staticClass: "rule_line", staticStyle: { color: "red" } },
            [
              _c("b", [_vm._v("白给50000以上，救援比例")]),
              _c("span", [_vm._v("10%")]),
            ]
          ),
          _c("div", { staticClass: "rule_line" }, [
            _c("span", [_vm._v("备注:")]),
            _c("br"),
            _c("span", [_vm._v("如未领取，不予累积")]),
          ]),
          _c("br"),
          _c("div", { staticClass: "rule_line" }, [
            _c("b", [_vm._v("月救援")]),
            _c("span", [_vm._v(": 月度总")]),
            _c("span", { staticStyle: { color: "#F5B844" } }, [
              _vm._v("充值500元以上"),
            ]),
            _c("span", [_vm._v("可领取，领取比例为")]),
            _c("span", { staticStyle: { color: "#F5B844" } }, [
              _vm._v("月白给的5%"),
            ]),
            _c("span", [_vm._v("。 月救援计算周期为")]),
            _c("span", { staticStyle: { color: "#F5B844" } }, [
              _vm._v("上个月的13号-到本月的13号。 "),
            ]),
            _c("span", { staticStyle: { color: "#F5B844" } }, [
              _vm._v("于14号17：30结算。"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }